export default {"src":"/_next/static/media/SyncButtonOrange.ee8227ae.svg","height":16,"width":16};